import React, { Component } from 'react'
import propType from 'prop-types'

import styles from './popup.styl'

export default class CookieConsent extends Component {
  static propTypes = {
    children: propType.node
  }

  render() {
    return (
      <div className={styles.popupOverlay}>
        <div className={styles.popupContent}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
